module.exports = __webpack_public_path__ + "media/images/external-link-10ddaa5e7c2e1bfce2899da183dcf1ce.svg";